import { render, staticRenderFns } from "./manualConsult.vue?vue&type=template&id=024d9e6f&scoped=true&"
import script from "./manualConsult.js?vue&type=script&lang=js&"
export * from "./manualConsult.js?vue&type=script&lang=js&"
import style0 from "./manualConsult.css?vue&type=style&index=0&id=024d9e6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d9e6f",
  null
  
)

export default component.exports